import React, { useEffect, useState } from "react";
import LoginImage from "../Assets/images/Login.png"
import Admin from "./Admin";
import Subadmin from "./Subadmin";
import { deleteAllCookies } from "../Helpers/Utils";

const Login = () => {
    const [admin, setAdmin] = useState(false)
    useEffect(() => {
        deleteAllCookies();
        localStorage.clear();
        sessionStorage.clear();
    }, [])
    return (
        <React.Fragment>
            <div className="container-fluid">
                <div className="row align-items-center justify-content-center login-row">
                    <div className="col-lg-6 ">
                        <div className="login-card">
                            <div className="row align-items-center">
                                <div className="col-lg-6"> <img src={LoginImage} alt="Login" /></div>
                                <div className="col-lg-6 px-5">
                                    <h4 className="mb-4 login-title">{admin ? "Admin" : "Subadmin"} Login</h4>
                                    {
                                        admin ?
                                            <Admin />
                                            :
                                            <Subadmin />
                                    }
                                    <div className="text-center mt-3">Are you an {!admin ? " Admin" : " Subadmin"}? <button className="login-link" onClick={() => setAdmin(!admin)}>Login</button></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Login;